import { RejectedBankAccount } from './types'

const withoutLeadingZeros = (value: string) => value.replace(/^0+(?=.)/, '')

const toComparable = (value: string | number | undefined) => String(value ?? '')

export const isSameRejectedBankAccount = (
  current: RejectedBankAccount,
  rejected: RejectedBankAccount | null | undefined,
) => {
  if (!rejected) {
    return false
  }

  const hasSameBankCode = toComparable(current.bankCode) === toComparable(rejected.bankCode)
  const hasSameAccountType =
    toComparable(current.accountType) === toComparable(rejected.accountType)
  const hasSameAccountDigit =
    toComparable(current.accountDigit) === toComparable(rejected.accountDigit)
  const hasSameBankBranch =
    withoutLeadingZeros(toComparable(current.bankBranch)) ===
    withoutLeadingZeros(toComparable(rejected.bankBranch))
  const hasSameAccountNumber =
    withoutLeadingZeros(toComparable(current.accountNumber)) ===
    withoutLeadingZeros(toComparable(rejected.accountNumber))

  return [
    hasSameBankCode,
    hasSameAccountType,
    hasSameAccountDigit,
    hasSameBankBranch,
    hasSameAccountNumber,
  ].every(Boolean)
}
